var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-slider-box -saturation-slider"},[_c('span',[_vm._v("Saturation")]),_vm._v(" "),_c('div',{ref:"slider",staticClass:"-slider",style:([_vm.backgroundReflection]),on:{"mousedown":function($event){_vm.mouseDown($event);
      _vm.clickOnSlider($event);}}},[_c('div',{ref:"handle",staticClass:"-handle",style:({
        left: _vm.sliderPosition - 2 + '%',
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }